import { NgModule } from '@angular/core';
import { SafePipe } from 'src/app/shared/pipes/safe/safe.pipe';

@NgModule({
  imports: [],
  declarations: [ 
    SafePipe
  ],
  exports: [
    SafePipe
  ]
})
export class PipesModule{}